
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../static/popup.scss';
import { Navigate } from 'react-router-dom';
 
 // Custom CSS for SVG filters

function Services() {
    const navigate = useNavigate(); // ✅ Call the hook directly inside the function component
    const handleClick = (c) => {
        navigate(`/index?id=${encodeURIComponent(c)}`);
    }
     

    const chars = ['New Grooming with Phone', 'New Grooming', 'Grooming with Name',
         'Grooming List Today',  'Grooming List Tomorrow', 'Grooming List Weekly',
          'Pet Walking day','Pet Walking Week', 'Day Care', 'VIP Client', 
          'Teeth', 'Teeth Ultrasound', 'Week Appointment', 'Today Appointment', 
          'Tomorrow Appointment', 'Stuff', 'Last Notes',
          'owners'];

    return (
        <div>
            {/* Hidden SVG filters */}
            
            {/* Main popup trigger button */}
         
            {/* Pop-up with image */}
            

            {/* Buttons from character array */}
            <form>
                {chars.map((c, index) => (
                    <div className='divi' key={index}>
                    <button type="button" onClick={() => handleClick(c)}>
                    {c}
                    </button>
                    </div> 
                   
                ))}
            </form>
        </div>
    );
}

export default Services;
